export default __webpack_public_path__ + "static/media/line1.a9c540a2.svg";